import React, { useState } from 'react';
import useGameService from 'services/GameService';

import ActionButton, { HAND_END_BUTTON_MAX_WIDTH } from './ActionButton';

const ShowCard = () => {
  const { showCard } = useGameService();
  // Hide immediately on click so the tap feels instant instead of waiting for
  // the server to clear the showCard flag (which unmounts this component). A
  // fresh instance mounts next time the action is offered, resetting this.
  const [clicked, setClicked] = useState(false);

  if (clicked) return null;

  const handleClick = () => {
    setClicked(true);
    showCard();
  };

  return (
    <ActionButton
      variant='call'
      icon='check'
      maxWidth={HAND_END_BUTTON_MAX_WIDTH}
      onClick={handleClick}>
      Show Cards
    </ActionButton>
  );
};

export default ShowCard;
